<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12">
        <div class="d-flex h-100">
          <SideBar></SideBar>
          <div class="pa-5 w-100">
            <BreadCrumb :linksData="linksData" class="mb-5" />
            <div>
              <div
                class="leads-managements-link d-flex align-center ga-2 my-3 py-3"
              >
                <div
                  @click="$router.push({ name: 'EngagementAndInsights' })"
                  class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L  7.825 11H20V13H7.825Z"
                      fill="#1F666A"
                    />
                  </svg>
                  <span>Engagement & Insights</span>
                </div>
              </div>
              <v-row>
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col cols="8">
                      <div class="post">
                        <div class="d-flex flex-wrap align-center ga-3 data">
                          <div
                            class="element d-flex align-center ga-2"
                            style="box-shadow: 0px 7.37px 44.24px 0px #dedede80"
                          >
                            <span class="title">Platform :</span
                            ><span
                              v-if="post.platform"
                              class="value text-capitalize"
                              >{{ post.platform }}</span
                            >
                            <span v-else>No platform</span>
                          </div>
                          <div
                            class="element d-flex align-center ga-2"
                            style="box-shadow: 0px 7.37px 44.24px 0px #dedede80"
                          >
                            <span class="title">Date of publish :</span
                            ><span v-if="post.publish_date" class="value">
                              {{ post.publish_date.split(" ")[0] }}
                            </span>
                            <span v-else>No data</span>
                          </div>
                        </div>
                      </div>
                      <div class="post w-100 mt-5">
                        <div
                          class="element d-flex flex-column ga-3 pa-4"
                          style="
                            height: auto;
                            box-shadow: 0px 7.37px 44.24px 0px #dedede80;
                          "
                        >
                          <div
                            class="d-flex justify-space-between align-center title"
                          >
                            <span>Caption</span>
                            <svg
                              @click="
                                $router.push({
                                  name: 'EngagementAndInsightsEditPost',
                                  params: {
                                    id: post.id,
                                    platform: post.platform,
                                  },
                                })
                              "
                              class="cursor-pointer"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_4993_149817)">
                                <path
                                  d="M11.334 1.99955C11.5091 1.82445 11.7169 1.68556 11.9457 1.5908C12.1745 1.49604 12.4197 1.44727 12.6673 1.44727C12.9149 1.44727 13.1601 1.49604 13.3889 1.5908C13.6177 1.68556 13.8256 1.82445 14.0007 1.99955C14.1757 2.17465 14.3146 2.38252 14.4094 2.61129C14.5042 2.84006 14.5529 3.08526 14.5529 3.33288C14.5529 3.58051 14.5042 3.8257 14.4094 4.05448C14.3146 4.28325 14.1757 4.49112 14.0007 4.66622L5.00065 13.6662L1.33398 14.6662L2.33398 10.9996L11.334 1.99955Z"
                                  stroke="#666666"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_4993_149817">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="value">
                            <span v-if="post.post">
                              {{ post.post }}
                            </span>
                            <span v-else> No data </span>
                          </div>
                        </div>
                      </div>
                      <div class="post w-100 mt-5">
                        <div
                          class="element d-flex flex-column ga-4 ma-0 pa-2"
                          style="
                            height: auto;
                            box-shadow: 0px 7.37px 44.24px 0px #dedede80;
                          "
                        >
                          <div
                            class="d-flex justify-space-between align-center w-100 pa-2 rounded"
                          >
                            <span class="d-flex align-center ga-2 title">
                              <svg
                                width="42"
                                height="43"
                                viewBox="0 0 42 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <ellipse
                                  cx="20.7571"
                                  cy="21.058"
                                  rx="20.7571"
                                  ry="21.058"
                                  fill="#DDECED"
                                  fill-opacity="0.4"
                                />
                                <path
                                  d="M13.5026 14H28.4974H29V14.5026V26.8105V27.3131H28.4974H13.5026H13V26.8105V14.5026V14H13.5026ZM27.9948 15.0052H14.0052V26.3079H27.9948V15.0052Z"
                                  fill="#237276"
                                />
                                <path
                                  d="M13.5026 17.3867H28.4974H29V17.8893V26.8077V27.3103H28.4974H13.5026H13V26.8077V17.8893V17.3867H13.5026ZM27.9948 18.392H14.0052V26.305H27.9948V18.392Z"
                                  fill="#237276"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14.8438 15.6953H15.849V16.7005H14.8438V15.6953Z"
                                  fill="#237276"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M16.7734 15.6953H17.7787V16.7005H16.7734V15.6953Z"
                                  fill="#237276"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M18.7031 15.6953H19.7084V16.7005H18.7031V15.6953Z"
                                  fill="#237276"
                                />
                                <path
                                  d="M23.6179 22.351C22.9842 21.6167 21.038 19.8708 18.4431 22.351C21.038 24.8313 22.9842 23.0854 23.6179 22.351ZM17.372 22.0094C21.5977 17.4606 24.6587 22.0553 24.6676 22.0683L24.8607 22.351L24.6676 22.6338C24.6587 22.6468 21.5977 27.2415 17.372 22.6927L17.0547 22.351L17.372 22.0094Z"
                                  fill="#237276"
                                />
                                <path
                                  d="M21.0026 22.8529C21.2802 22.8529 21.5052 22.6279 21.5052 22.3503C21.5052 22.0727 21.2802 21.8477 21.0026 21.8477C20.725 21.8477 20.5 22.0727 20.5 22.3503C20.5 22.6279 20.725 22.8529 21.0026 22.8529Z"
                                  fill="#237276"
                                />
                              </svg>
                              <span>Total Impressions</span>
                            </span>
                            <span class="value">{{ post.reach }}</span>
                          </div>
                          <div
                            class="d-flex justify-space-between align-center w-100 pa-2 rounded"
                          >
                            <span class="d-flex align-center ga-2 title">
                              <svg
                                width="42"
                                height="43"
                                viewBox="0 0 42 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <ellipse
                                  cx="20.7571"
                                  cy="21.1752"
                                  rx="20.7571"
                                  ry="21.058"
                                  fill="#DDECED"
                                  fill-opacity="0.4"
                                />
                                <g clip-path="url(#clip0_25_75181)">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M29.4375 15C29.4375 14.602 29.2598 14.2205 28.9431 13.9395C28.6269 13.658 28.1978 13.5 27.75 13.5C24.8509 13.5 17.1491 13.5 14.25 13.5C13.8023 13.5 13.3731 13.658 13.0569 13.9395C12.7402 14.2205 12.5625 14.602 12.5625 15V27C12.5625 27.398 12.7402 27.7795 13.0569 28.0605C13.3731 28.342 13.8023 28.5 14.25 28.5H27.75C28.1978 28.5 28.6269 28.342 28.9431 28.0605C29.2598 27.7795 29.4375 27.398 29.4375 27V15ZM28.3125 18.5035V27C28.3125 27.1325 28.2534 27.26 28.1477 27.3535C28.0425 27.4475 27.8991 27.5 27.75 27.5H14.25C14.1009 27.5 13.9575 27.4475 13.8523 27.3535C13.7466 27.26 13.6875 27.1325 13.6875 27V18.5035H28.3125ZM28.3125 17.5035H13.6875V15C13.6875 14.8675 13.7466 14.74 13.8523 14.6465C13.9575 14.5525 14.1009 14.5 14.25 14.5H27.75C27.8991 14.5 28.0425 14.5525 28.1477 14.6465C28.2534 14.74 28.3125 14.8675 28.3125 15V17.5035Z"
                                    fill="#237276"
                                  />
                                  <path
                                    d="M15.3672 16.6289C15.7555 16.6289 16.0703 16.3491 16.0703 16.0039C16.0703 15.6587 15.7555 15.3789 15.3672 15.3789C14.9789 15.3789 14.6641 15.6587 14.6641 16.0039C14.6641 16.3491 14.9789 16.6289 15.3672 16.6289Z"
                                    fill="#237276"
                                  />
                                  <path
                                    d="M17.6328 16.6172C18.0211 16.6172 18.3359 16.3374 18.3359 15.9922C18.3359 15.647 18.0211 15.3672 17.6328 15.3672C17.2445 15.3672 16.9297 15.647 16.9297 15.9922C16.9297 16.3374 17.2445 16.6172 17.6328 16.6172Z"
                                    fill="#237276"
                                  />
                                  <path
                                    d="M19.8672 16.6289C20.2555 16.6289 20.5703 16.3491 20.5703 16.0039C20.5703 15.6587 20.2555 15.3789 19.8672 15.3789C19.4789 15.3789 19.1641 15.6587 19.1641 16.0039C19.1641 16.3491 19.4789 16.6289 19.8672 16.6289Z"
                                    fill="#237276"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.9965 20.1615C20.0054 19.3025 18.5513 19.435 17.7672 20.097C16.9162 20.8155 16.8053 22.25 17.653 23.6865C18.1919 24.6545 19.5498 25.637 20.6956 26.282C20.8795 26.3855 21.1135 26.3855 21.2975 26.282C22.4433 25.637 23.8012 24.6545 24.34 23.6865C25.1877 22.25 25.0769 20.8155 24.2258 20.097C23.4417 19.435 21.9877 19.3025 20.9965 20.1615ZM20.5066 21.2255C20.6062 21.383 20.7935 21.48 20.9965 21.48C21.1996 21.48 21.3869 21.383 21.4865 21.2255C21.9803 20.447 22.9574 20.405 23.4513 20.822C23.7038 21.035 23.809 21.3615 23.809 21.7345C23.809 22.189 23.6487 22.707 23.341 23.2265C23.3382 23.231 23.336 23.235 23.3337 23.239C22.9208 23.986 21.9112 24.72 20.9965 25.263C20.0819 24.7205 19.0722 23.986 18.6593 23.239C18.6571 23.235 18.6548 23.231 18.652 23.2265C18.3443 22.707 18.184 22.189 18.184 21.7345C18.184 21.3615 18.2892 21.035 18.5418 20.822C19.0357 20.405 20.0127 20.447 20.5066 21.2255Z"
                                    fill="#237276"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_25_75181">
                                    <rect
                                      width="18"
                                      height="16"
                                      fill="white"
                                      transform="translate(12 13)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>

                              <span>Total Engagements</span>
                            </span>
                            <span class="value">{{ post.engagement }}</span>
                          </div>
                          <div
                            class="d-flex justify-space-between align-center w-100 pa-2 rounded"
                          >
                            <span class="d-flex align-center ga-2 title">
                              <svg
                                width="42"
                                height="43"
                                viewBox="0 0 42 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <ellipse
                                  cx="20.7571"
                                  cy="21.2884"
                                  rx="20.7571"
                                  ry="21.058"
                                  fill="#DDECED"
                                  fill-opacity="0.4"
                                />
                                <g clip-path="url(#clip0_25_75194)">
                                  <path
                                    d="M25.535 22.7485L27.9554 21.1492L18.1875 18.1641L21.1727 27.932L22.7719 25.5115L26.2366 28.9763L28.9997 26.2132L25.535 22.7485ZM22.5728 23.5423L21.5932 25.0249L20.0725 20.049L25.0484 21.5697L23.5657 22.5493L27.2295 26.2131L26.2366 27.206L22.5728 23.5423Z"
                                    fill="#237276"
                                  />
                                  <path
                                    d="M15.1769 21.755C14.28 20.5529 14.0209 19.0059 14.4654 17.5108C14.6769 16.7949 15.0642 16.1434 15.592 15.6156C16.1199 15.0877 16.7714 14.7004 17.4873 14.4889C18.9824 14.0443 20.5294 14.3037 21.7315 15.2004C22.3191 15.6344 22.7962 16.2007 23.124 16.8535C23.4518 17.5063 23.621 18.2271 23.6181 18.9576H24.8699C24.8705 18.0326 24.6548 17.1204 24.2398 16.2937C23.8248 15.4671 23.2222 14.749 22.48 14.197C20.958 13.0617 19.0082 12.7307 17.1306 13.289C16.2162 13.5617 15.384 14.0579 14.7092 14.7327C14.0345 15.4074 13.5383 16.2396 13.2656 17.1541C12.7073 19.0316 13.0382 20.9814 14.1735 22.5035C14.7256 23.2456 15.4437 23.8482 16.2703 24.2632C17.0969 24.6782 18.0092 24.8939 18.9341 24.8933V23.6415C18.2037 23.6445 17.4828 23.4752 16.83 23.1474C16.1772 22.8197 15.6109 22.3426 15.1769 21.755Z"
                                    fill="#237276"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_25_75194">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(13 13)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>

                              <span>Total Clicks</span>
                            </span>
                            <span class="value">{{ post.clicks || "--" }}</span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div
                        class="bg-white pa-6"
                        style="
                          box-shadow: 0px 7.37px 44.24px 0px #dedede80;
                          height: 100%;
                        "
                      >
                        <p
                          v-if="post.media_type == 'VIDEO'"
                          style="font-weight: bold; margin-bottom: 1rem"
                        >
                          post video
                        </p>
                        <p v-else>post image</p>
                        <div v-if="post.media_type == 'VIDEO'" w-100 h-100>
                          <div v-if="post.image">
                            <video
                              :src="post.image"
                              style="height: 90%;max-height: 19rem;"
                              class="w-100"
                            ></video>
                          </div>
                          <img
                            style="max-height: 18rem; width: 100%"
                            v-else
                            src="@/assets/images/noimg.png"
                            alt="noimg"
                          />
                        </div>
                        <div class="w-100 h-100" v-else>
                          <div
                            v-if="post.image"
                            style="
                              height: 90%;
                              
                              background-size: cover;
                            "
                            class="post-image-background"
                            :style="
                              post.image
                                ? `background-image: url(${post.image});`
                                : ''
                            "
                          ></div>
                          <img
                            style="max-height: 18rem; width: 100%"
                            v-else
                            src="@/assets/images/noimg.png"
                            alt="noimg"
                          />
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row class="mt-5">
                    <v-col cols="4" class="post">
                      <div
                        class="element rectangle d-flex flex-column align-center justify-center ga-3"
                      >
                        <div class="title">Reacts</div>
                        <svg
                          width="52"
                          height="53"
                          viewBox="0 0 52 53"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="25.8344"
                            cy="26.3242"
                            rx="25.436"
                            ry="25.8046"
                            fill="#DDECED"
                            fill-opacity="0.4"
                          />
                          <path
                            d="M30.4749 34H24.9507C23.1219 34 22.525 33.5862 21.5427 32.5692C21.4804 32.5107 21.4307 32.4401 21.3965 32.3618C21.3623 32.2835 21.3444 32.1991 21.3438 32.1137C21.3431 32.0283 21.3598 31.9436 21.3929 31.8648C21.4259 31.786 21.4746 31.7147 21.5359 31.6553C21.5973 31.5959 21.6701 31.5495 21.7499 31.519C21.8297 31.4885 21.9149 31.4745 22.0002 31.4778C22.0856 31.4812 22.1694 31.5018 22.2466 31.5385C22.3237 31.5751 22.3926 31.6271 22.4492 31.6911C23.1851 32.4523 23.463 32.7366 24.9507 32.7366H30.4749C30.7436 32.7366 31.0037 32.6415 31.2089 32.468C31.4142 32.2946 31.5514 32.054 31.5962 31.7891L32.4268 27.2377C32.4537 27.1174 32.5152 27.0076 32.6037 26.9218C33.2354 26.2901 33.4407 25.6426 33.1975 25.052C33.1091 24.8248 32.9603 24.6261 32.7671 24.4775C32.5739 24.3288 32.3438 24.2359 32.1015 24.2087H29.2589C29.1667 24.2099 29.0754 24.1909 28.9913 24.153C28.9072 24.1151 28.8325 24.0593 28.7723 23.9895C28.7121 23.9197 28.6679 23.8375 28.6428 23.7488C28.6178 23.66 28.6124 23.5669 28.6272 23.4759C28.6272 23.4569 28.9178 21.6913 28.6272 20.5732C28.4345 19.7994 28.1187 19.3098 27.806 19.2783C27.7152 19.2788 27.626 19.3012 27.5457 19.3435C27.4654 19.3859 27.3965 19.4469 27.3448 19.5215C27.3448 20.2321 27.3101 21.9788 25.8951 23.3938C24.4801 24.8088 22.1744 25.1341 22.0828 25.1467C21.9998 25.1584 21.9154 25.1535 21.8343 25.1325C21.7532 25.1115 21.6771 25.0747 21.6102 25.0243C21.5433 24.9738 21.487 24.9107 21.4446 24.8385C21.4021 24.7663 21.3743 24.6864 21.3626 24.6035C21.351 24.5205 21.3559 24.4361 21.3769 24.355C21.3979 24.2739 21.4347 24.1978 21.4851 24.1309C21.5356 24.064 21.5987 24.0077 21.6709 23.9653C21.7431 23.9228 21.8229 23.895 21.9059 23.8833C21.9438 23.8833 23.9337 23.5675 25.0233 22.4841C26.113 21.4008 26.1004 20.0395 26.1004 19.4551C26.1004 18.7855 26.8016 18.1096 27.5975 18.0117C28.0965 17.9517 29.3189 18.0433 29.8716 20.2511C30.0463 21.133 30.0804 22.0369 29.9727 22.9295H32.1015C32.5931 22.9579 33.0666 23.1253 33.4669 23.4121C33.8672 23.6989 34.178 24.0934 34.363 24.5498C34.7862 25.57 34.5178 26.6881 33.6365 27.6514L32.8406 32.0291C32.7393 32.5826 32.4471 33.0829 32.0148 33.4431C31.5825 33.8032 31.0375 34.0003 30.4749 34Z"
                            fill="#237276"
                          />
                          <path
                            d="M21.9923 33.9282H18.6317C18.4642 33.9282 18.3035 33.8617 18.185 33.7432C18.0666 33.6247 18 33.464 18 33.2965V23.7958C18 23.6282 18.0666 23.4675 18.185 23.3491C18.3035 23.2306 18.4642 23.1641 18.6317 23.1641H21.9923C22.1599 23.1641 22.3205 23.2306 22.439 23.3491C22.5575 23.4675 22.624 23.6282 22.624 23.7958V33.2965C22.624 33.464 22.5575 33.6247 22.439 33.7432C22.3205 33.8617 22.1599 33.9282 21.9923 33.9282ZM19.2634 32.6648H21.3606V24.4275H19.2634V32.6648Z"
                            fill="#237276"
                          />
                        </svg>

                        <div v-if="post.reactions" class="value">
                          {{ post.reactions }}
                        </div>
                        <div v-else>0</div>
                      </div>
                    </v-col>
                    <v-col cols="4" class="post">
                      <div
                        class="element rectangle d-flex flex-column align-center justify-center ga-3"
                      >
                        <div class="title">Comments</div>
                        <svg
                          width="51"
                          height="53"
                          viewBox="0 0 51 53"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="25.4985"
                            cy="26.3242"
                            rx="25.436"
                            ry="25.8046"
                            fill="#DDECED"
                            fill-opacity="0.4"
                          />
                          <g clip-path="url(#clip0_25_75220)">
                            <path
                              d="M20.9974 31.3333V33.3333C20.9974 33.4601 21.0335 33.5843 21.1015 33.6912C21.1695 33.7982 21.2666 33.8836 21.3814 33.9373C21.4965 33.9901 21.6241 34.0094 21.7496 33.9932C21.8751 33.9769 21.9936 33.9257 22.0914 33.8453L25.1054 31.3333H28.9974C29.8811 31.3323 30.7284 30.9807 31.3533 30.3559C31.9781 29.731 32.3297 28.8837 32.3307 28V21.3333C32.3297 20.4496 31.9781 19.6024 31.3533 18.9775C30.7284 18.3526 29.8811 18.0011 28.9974 18H20.9974C20.1137 18.0011 19.2664 18.3526 18.6415 18.9775C18.0167 19.6024 17.6651 20.4496 17.6641 21.3333V28C17.6651 28.8837 18.0167 29.731 18.6415 30.3559C19.2664 30.9807 20.1137 31.3323 20.9974 31.3333ZM18.9974 21.3333C18.9974 20.8029 19.2081 20.2942 19.5832 19.9191C19.9583 19.544 20.467 19.3333 20.9974 19.3333H28.9974C29.5278 19.3333 30.0365 19.544 30.4116 19.9191C30.7867 20.2942 30.9974 20.8029 30.9974 21.3333V28C30.9974 28.5304 30.7867 29.0391 30.4116 29.4142C30.0365 29.7893 29.5278 30 28.9974 30H25.1054C24.7933 30 24.4911 30.1095 24.2514 30.3093L22.3307 31.91V31.3333C22.3307 30.9797 22.1903 30.6406 21.9402 30.3905C21.6902 30.1405 21.351 30 20.9974 30C20.467 30 19.9583 29.7893 19.5832 29.4142C19.2081 29.0391 18.9974 28.5304 18.9974 28V21.3333Z"
                              fill="#237276"
                            />
                            <path
                              d="M21.6667 22.6654H28.3333C28.5101 22.6654 28.6797 22.5951 28.8047 22.4701C28.9298 22.3451 29 22.1755 29 21.9987C29 21.8219 28.9298 21.6523 28.8047 21.5273C28.6797 21.4023 28.5101 21.332 28.3333 21.332H21.6667C21.4899 21.332 21.3203 21.4023 21.1953 21.5273C21.0702 21.6523 21 21.8219 21 21.9987C21 22.1755 21.0702 22.3451 21.1953 22.4701C21.3203 22.5951 21.4899 22.6654 21.6667 22.6654Z"
                              fill="#237276"
                            />
                            <path
                              d="M21.6667 25.3333H28.3333C28.5101 25.3333 28.6797 25.2631 28.8047 25.1381C28.9298 25.013 29 24.8435 29 24.6667C29 24.4899 28.9298 24.3203 28.8047 24.1953C28.6797 24.0702 28.5101 24 28.3333 24H21.6667C21.4899 24 21.3203 24.0702 21.1953 24.1953C21.0702 24.3203 21 24.4899 21 24.6667C21 24.8435 21.0702 25.013 21.1953 25.1381C21.3203 25.2631 21.4899 25.3333 21.6667 25.3333Z"
                              fill="#237276"
                            />
                            <path
                              d="M21.6667 28.0013H25.6667C25.8435 28.0013 26.013 27.9311 26.1381 27.806C26.2631 27.681 26.3333 27.5114 26.3333 27.3346C26.3333 27.1578 26.2631 26.9883 26.1381 26.8632C26.013 26.7382 25.8435 26.668 25.6667 26.668H21.6667C21.4899 26.668 21.3203 26.7382 21.1953 26.8632C21.0702 26.9883 21 27.1578 21 27.3346C21 27.5114 21.0702 27.681 21.1953 27.806C21.3203 27.9311 21.4899 28.0013 21.6667 28.0013Z"
                              fill="#237276"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_25_75220">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(17 18)"
                              />
                            </clipPath>
                          </defs>
                        </svg>

                        <div v-if="post.comments" class="value">
                          {{ post.comments }}
                        </div>
                        <div v-else>0</div>
                      </div>
                    </v-col>
                    <v-col cols="4" class="post">
                      <div
                        class="element rectangle d-flex flex-column align-center justify-center ga-3"
                      >
                        <div class="title">Share</div>
                        <svg
                          width="52"
                          height="53"
                          viewBox="0 0 52 53"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="26.1704"
                            cy="26.3242"
                            rx="25.436"
                            ry="25.8046"
                            fill="#DDECED"
                            fill-opacity="0.4"
                          />
                          <path
                            d="M19.7493 31.4093C19.7696 31.353 19.7915 31.2968 19.8149 31.2421C19.7883 31.3046 19.7618 31.3671 19.7368 31.428C19.8743 31.1015 20.0555 30.7937 20.2712 30.5124C20.2305 30.5655 20.1899 30.6171 20.1493 30.6702C20.3993 30.3484 20.6915 30.064 21.0133 29.8155C20.9602 29.8562 20.9087 29.8968 20.8555 29.9374C21.3258 29.5765 21.8477 29.2905 22.393 29.0609C22.3305 29.0874 22.268 29.114 22.2071 29.139C23.004 28.8046 23.8462 28.5827 24.6962 28.4312C24.9243 28.3905 25.154 28.3546 25.3837 28.3249C25.3149 28.3343 25.2446 28.3437 25.1758 28.353C25.7696 28.2734 26.368 28.2249 26.9665 28.203C27.093 28.1984 27.2196 28.1952 27.3462 28.1937C27.0852 27.9327 26.8258 27.6734 26.5649 27.4124C26.5649 28.014 26.5555 28.6155 26.5649 29.2155C26.568 29.4343 26.6212 29.6562 26.7337 29.8452C26.8962 30.1171 27.143 30.2905 27.4368 30.3952C27.6587 30.4749 27.9571 30.4718 28.1758 30.3859C28.3696 30.3109 28.4774 30.2452 28.6399 30.1109C28.7462 30.0234 28.8508 29.9327 28.9571 29.8452C29.5024 29.389 30.0462 28.9312 30.5915 28.4749C31.2227 27.9452 31.854 27.4171 32.4852 26.8874C32.704 26.703 32.9243 26.5187 33.143 26.3359C33.2321 26.2609 33.3243 26.1905 33.4102 26.1109C33.6477 25.889 33.7821 25.553 33.7821 25.2312C33.7821 25.103 33.7649 24.9687 33.718 24.8484C33.6477 24.6624 33.5587 24.489 33.4102 24.3515C33.3852 24.328 33.3571 24.3062 33.3305 24.2843C33.1743 24.153 33.018 24.0234 32.8618 23.8921C32.2712 23.3968 31.6805 22.9015 31.0899 22.4077C30.4852 21.9015 29.8821 21.3952 29.2774 20.889C29.0993 20.739 28.9196 20.589 28.7415 20.4405C28.7071 20.4109 28.6727 20.3827 28.6368 20.353C28.4696 20.214 28.3743 20.1546 28.1743 20.078C27.954 19.9937 27.6587 19.989 27.4352 20.0687C27.1399 20.1734 26.8946 20.3484 26.7321 20.6187C26.618 20.8077 26.5665 21.0296 26.5633 21.2484C26.5618 21.3577 26.5633 21.4671 26.5633 21.5765V22.7765V23.0327C26.8243 22.7718 27.0837 22.5124 27.3446 22.2515C26.7227 22.2655 26.1008 22.3327 25.4883 22.4343C24.7633 22.5546 24.0477 22.7452 23.3665 23.0202C22.929 23.1968 22.4993 23.3921 22.0915 23.6327C21.6696 23.8812 21.2712 24.1734 20.9008 24.4921C20.1477 25.1421 19.5258 25.9671 19.104 26.8671C18.843 27.4265 18.6368 28.003 18.4977 28.6015C18.3399 29.2843 18.254 29.9874 18.2243 30.6874C18.2165 30.8593 18.2133 31.0296 18.2133 31.2015C18.2133 31.4015 18.3008 31.6124 18.4415 31.7546C18.5774 31.8905 18.7993 31.9921 18.9946 31.9827C19.1962 31.9734 19.4055 31.9077 19.5477 31.7546C19.6883 31.6015 19.7758 31.414 19.7758 31.2015C19.7758 30.6937 19.8055 30.1874 19.8727 29.6843C19.8633 29.753 19.854 29.8234 19.8446 29.8921C19.9446 29.1484 20.1274 28.4171 20.418 27.7249C20.3915 27.7874 20.3649 27.8499 20.3399 27.9109C20.5665 27.3734 20.8587 26.8655 21.2149 26.403C21.1743 26.4562 21.1337 26.5077 21.093 26.5609C21.4368 26.1155 21.8383 25.7171 22.2837 25.3718C22.2305 25.4124 22.179 25.453 22.1258 25.4937C22.5399 25.1749 22.9868 24.9015 23.4571 24.6749C23.5852 24.6124 23.7149 24.5546 23.8462 24.4999C23.7837 24.5265 23.7212 24.553 23.6602 24.578C24.3258 24.2984 25.0243 24.0999 25.7337 23.9718C25.9102 23.939 26.0868 23.9124 26.2633 23.8874C26.1946 23.8968 26.1243 23.9062 26.0555 23.9155C26.404 23.8687 26.754 23.8374 27.104 23.8218C27.1837 23.8187 27.2649 23.8155 27.3446 23.814C27.7665 23.8046 28.1258 23.464 28.1258 23.0327C28.1258 22.5015 28.1258 21.9702 28.1258 21.439C28.1258 21.3546 28.1212 21.2671 28.129 21.1827C28.1196 21.2515 28.1102 21.3218 28.1008 21.3905C28.1071 21.3468 28.118 21.3077 28.1352 21.2671C28.1087 21.3296 28.0821 21.3921 28.0571 21.453C28.0727 21.4202 28.0899 21.3921 28.1118 21.3624C28.0712 21.4155 28.0305 21.4671 27.9899 21.5202C28.0149 21.489 28.043 21.4609 28.0758 21.4359C28.0227 21.4765 27.9712 21.5171 27.918 21.5577C27.9462 21.5374 27.9758 21.5202 28.0071 21.5062C27.9446 21.5327 27.8821 21.5593 27.8212 21.5843C27.8633 21.5671 27.9071 21.5546 27.9524 21.5484C27.8837 21.5577 27.8133 21.5671 27.7446 21.5765C27.779 21.5734 27.8133 21.5734 27.8477 21.5765C27.779 21.5671 27.7087 21.5577 27.6399 21.5484C27.6821 21.5546 27.7212 21.564 27.7602 21.5812C27.6977 21.5546 27.6352 21.528 27.5743 21.503C27.6087 21.5187 27.6415 21.5374 27.6712 21.5609C27.618 21.5202 27.5665 21.4796 27.5133 21.439C27.6805 21.5734 27.8415 21.714 28.0055 21.8515C28.3883 22.1734 28.7727 22.4937 29.1555 22.8155C29.618 23.203 30.0805 23.5905 30.543 23.978C30.9399 24.3109 31.3383 24.6437 31.7352 24.978C31.9196 25.1312 32.1055 25.2827 32.2868 25.4405C32.3149 25.4655 32.3399 25.4921 32.3633 25.5202C32.3227 25.4671 32.2821 25.4155 32.2415 25.3624C32.2618 25.3905 32.2774 25.4202 32.2915 25.4515C32.2649 25.389 32.2383 25.3265 32.2133 25.2655C32.229 25.303 32.2383 25.3405 32.2446 25.3812C32.2352 25.3124 32.2258 25.2421 32.2165 25.1734C32.2212 25.214 32.2212 25.253 32.2165 25.2921C32.2258 25.2234 32.2352 25.153 32.2446 25.0843C32.2383 25.1249 32.2274 25.1624 32.2133 25.1999C32.2399 25.1374 32.2665 25.0749 32.2915 25.014C32.2774 25.0452 32.2602 25.0749 32.2399 25.103C32.2805 25.0499 32.3212 24.9984 32.3618 24.9452C32.3102 25.0109 32.243 25.0609 32.179 25.114C32.0665 25.2077 31.954 25.303 31.8415 25.3968C31.4633 25.714 31.0852 26.0312 30.7071 26.3468C30.2446 26.7343 29.7837 27.1218 29.3212 27.5077C28.9196 27.8452 28.5165 28.1827 28.1149 28.5187C27.9212 28.6812 27.7274 28.8421 27.5352 29.0046C27.5274 29.0109 27.5196 29.0171 27.5133 29.0234C27.5665 28.9827 27.618 28.9421 27.6712 28.9015C27.6399 28.9249 27.6087 28.9437 27.5743 28.9593C27.6368 28.9327 27.6993 28.9062 27.7602 28.8812C27.7212 28.8968 27.6821 28.9077 27.6399 28.914C27.7087 28.9046 27.779 28.8952 27.8477 28.8859C27.8133 28.889 27.779 28.889 27.7446 28.8859C27.8133 28.8952 27.8837 28.9046 27.9524 28.914C27.9071 28.9077 27.8633 28.8952 27.8212 28.878C27.8837 28.9046 27.9462 28.9312 28.0071 28.9562C27.9758 28.9421 27.9462 28.9249 27.918 28.9046C27.9712 28.9452 28.0227 28.9859 28.0758 29.0265C28.043 29.0015 28.0149 28.9749 27.9899 28.9421C28.0305 28.9952 28.0712 29.0468 28.1118 29.0999C28.0899 29.0718 28.0727 29.0421 28.0571 29.0093C28.0837 29.0718 28.1102 29.1343 28.1352 29.1952C28.118 29.1546 28.1071 29.1155 28.1008 29.0718C28.1102 29.1405 28.1196 29.2109 28.129 29.2796C28.1071 29.0687 28.1258 28.8484 28.1258 28.6374C28.1258 28.3062 28.1258 27.9749 28.1258 27.6437C28.1258 27.5671 28.1258 27.489 28.1258 27.4124C28.1258 26.9952 27.768 26.6249 27.3446 26.6312C26.8587 26.6374 26.3727 26.664 25.8883 26.7093C25.193 26.7734 24.4993 26.8702 23.8149 27.0155C23.1352 27.1593 22.4633 27.3515 21.8227 27.6187C21.4462 27.7749 21.0758 27.9421 20.7227 28.1468C20.3774 28.3484 20.0524 28.5827 19.7446 28.839C19.4852 29.0562 19.2493 29.2984 19.0415 29.564C18.7946 29.8827 18.5727 30.2093 18.4102 30.5796C18.3508 30.7155 18.293 30.8515 18.2415 30.9905C18.1743 31.1702 18.2258 31.4327 18.3196 31.5921C18.4149 31.7546 18.6008 31.9093 18.7868 31.9515C18.9868 31.9968 19.2118 31.9874 19.3883 31.8734C19.4415 31.8327 19.493 31.7921 19.5462 31.7515C19.6446 31.6562 19.7118 31.5421 19.7493 31.4093Z"
                            fill="#237276"
                          />
                        </svg>

                        <div v-if="post.shares" class="value">
                          {{ post.shares }}
                        </div>
                        <div v-else>0</div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";
export default {
  name: "EngagementAndInsights",
  components: { BreadCrumb, GlobalNav, SideBar },
  data() {
    return {
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Engagement and Insights", link: "" },
      ],
      post: {},
      general_store: useGeneralStore(),
    };
  },
  methods: {
    async getPost() {
      await apiClient
        .get(`/engagement-insights/get-post/${this.$route.params.id}`, {
          params: {
            platform: this.$route.params.platform,
          },
        })
        .then((response) => {
          this.post = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.general_store.ShowLoading();
    this.getPost().finally(() => {
      this.general_store.HideLoading();
    });
  },
};
</script>

<style scoped>
.post .element {
  height: 40px;
  padding: 0px 24px 0px 16px;
  background-color: #ffffff;
  border-radius: 8px;
}
.post .element .title {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  color: #0d0d0d;
}
.post .element .value {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: #666666;
}

.post .rectangle {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 7.37px 44.24px 0px #dedede80;
  background: #ffffff;
  height: 100% !important;
}
</style>
